import { useCallback } from 'react';
import { getInitialStateForFileSettings } from '../utils';
import { DataRoomSecuritySettings } from '../models/DataRoom';

export default function useFileSecurityInitialValues() {
  return useCallback(
    ({
      fileSecurity,
      blurProtection,
      expirationDays,
      watermarkDiagonal,
      watermarkHeader,
      watermarkFooter,
      watermarkFullName,
      watermarkEmail,
      watermarkIpAddress,
    }: DataRoomSecuritySettings) => ({
      expirationDays,
      fileSecurity,
      blurProtection: getInitialStateForFileSettings(blurProtection),
      watermarkDiagonal: getInitialStateForFileSettings(watermarkDiagonal),
      watermarkHeader: getInitialStateForFileSettings(watermarkHeader),
      watermarkFooter: getInitialStateForFileSettings(watermarkFooter),
      watermarkFullName: getInitialStateForFileSettings(watermarkFullName),
      watermarkEmail: getInitialStateForFileSettings(watermarkEmail),
      watermarkIpAddress: getInitialStateForFileSettings(watermarkIpAddress),
    }),
    [],
  );
}
